import { createSlice } from "@reduxjs/toolkit";

const initialFilesState = {
    uploadedFiles: [],
    filterResult: null,
}

const filesSlice = createSlice({
    name: 'files',
    initialState: initialFilesState,
    reducers: {
        setUploadedFiles(state, data) {
            state.uploadedFiles = data.payload
        },
        removeFile(state, data) {
            const index = state.uploadedFiles.findIndex(object => {
                return object.id == data.payload.id
            })

            state.uploadedFiles.splice(index, 1)
        },
        setFilterResult(state, data) {
            state.filterResult = data.payload
        },
    }
})

export const filesActions = filesSlice.actions

export default filesSlice.reducer